import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ProfileUpdateDataServiceProvider {
	constructor(private http: HttpClient) {}

	changeUserName(user): Observable<any> {
		const url = '/protected/rest/user/edit';
		return this.http.post(url, user);
	}

	changeUserEmail(email: string): Observable<any> {
		const url = '/protected/rest/user/edit/login';
		return this.http.post(url, email);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/services/profile/profile-update.data.service.ts